import React from 'react';

import FilterContainer from './components/filter-container/filter-container';
import ForecastingGrid from './components/forecasting-grid/forecasting-grid';
import style from './styles.module.less';

/**
 * ForecastingDrawerContent component that displays the content of the forecasting drawer
 * @returns {React.ReactElement} The rendered ForecastingDrawerContent component
 */
export const ForecastingDrawerContent = () => {
  return (
    <div className={style['drawer-body']} role='main'>
      {/* oxlint-disable-next-line jsx-a11y/prefer-tag-over-role */}
      <div className={style['drawer-content']} role='region'>
        <FilterContainer />
        <ForecastingGrid />
      </div>
    </div>
  );
};
